export default __webpack_public_path__ + "static/media/Malia Cohen.5881783e.jpg";